import { Switch, Route, useLocation } from "wouter";
import { Suspense, useEffect, useRef } from "react";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";

function ScrollToTop() {
  const [location] = useLocation();
  const prevLocation = useRef(location);

  useEffect(() => {
    if (location !== prevLocation.current) {
      window.scrollTo(0, 0);
      prevLocation.current = location;
    }
  }, [location]);

  return null;
}

function CanonicalTag() {
  const [location] = useLocation();

  useEffect(() => {
    const existing = document.querySelector('link[rel="canonical"]');
    if (existing) existing.remove();
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href = `https://cracksseal.com${location}`;
    document.head.appendChild(link);
  }, [location]);

  return null;
}
import {
  Home,
  ServicePage,
  ServiceAreas,
  CountyPage,
  CityGroupPage,
  Gallery,
  Contact,
  PrivacyPolicy,
  NotFound,
} from "@/routes";

function Router() {
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/services/:slug" component={ServicePage} />
        <Route path="/service-areas" component={ServiceAreas} />
        <Route path="/service-areas/:county" component={CountyPage} />
        <Route path="/gallery" component={Gallery} />
        <Route path="/contact" component={Contact} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/mansfield-easton-norton-ma">
          {() => { window.location.replace("/north-attleborough-attleboro-ma"); return null; }}
        </Route>
        <Route path="/:groupSlug" component={CityGroupPage} />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <ScrollToTop />
        <CanonicalTag />
        <Router />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
